import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { ISmsTemplate } from 'src/app/models/interfaces/sms-template.interface';
import { SmsTemplateFormContext } from './sms-template-form-context';

export class SmsTemplateDetailContext extends DefaultDetailContext<ISmsTemplate, number> {
    private _global: boolean;

    public get global(): boolean {
        return this._global;
    }

    public set global(value: boolean) {
        this._global = value;
        (this.formContext as SmsTemplateFormContext).global = value;
    }
}
